<h2 class="tk-page__caption tk-title">Отладочная информация</h2>

<section class="tk-page__content">
  <tk-about></tk-about>
</section>
